import img1 from './img/p1.png';
import img2 from './img/p2.png';
import img3 from './img/p3.png';
import img4 from './img/p4.png';
import img5 from './img/p5.png';
import img6 from './img/p6.png';
import img7 from './img/p7.png';
import img8 from './img/p8.png';
import img9 from './img/p9.png';
import img10 from './img/p10.png';
import img11 from './img/p11.png';
import img12 from './img/p12.png';
import img13 from './img/p13.png';
import img14 from './img/p14.png';
import img15 from './img/p15.png';
import img16 from './img/p16.png';
import img17 from './img/p17.png';
import img18 from './img/p18.png';
import img19 from './img/p19.png';


const products = [
    {
        "id": "1001",
        "code": "f230fh0g3",
        "name": "Bamboo Watch",
        "description": "Product Description",
        "image": img1,
        "price": 65,
        "category": "Accessories",
        "quantity": 24,
        "inventoryStatus": "INSTOCK",
        "rating": 5
    },
    {
        "id": "1002",
        "code": "nvklal433",
        "name": "Black Watch",
        "description": "Product Description",
        "image": img2,
        "price": 72,
        "category": "Accessories",
        "quantity": 61,
        "inventoryStatus": "INSTOCK",
        "rating": 4
    },
    {
        "id": "1003",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img3,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1004",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img4,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1005",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img5,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1006",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img6,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1007",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img7,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1008",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img8,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1009",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img9,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1010",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img10,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1011",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img11,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1012",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img12,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1013",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img13,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1014",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img14,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1015",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img15,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1016",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img16,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1017",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img17,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1018",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img18,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    },
    {
        "id": "1019",
        "code": "zz21cz3c1",
        "name": "Blue Band",
        "description": "Product Description",
        "image": img19,
        "price": 79,
        "category": "Fitness",
        "quantity": 2,
        "inventoryStatus": "LOWSTOCK",
        "rating": 3
    }
];
export default products;